import React, { FC, JSX } from 'react'

import { InterSvgIcon } from 'components'
import { Button } from 'common/styles/layouts'
import { IS_SEND_DOCUMENTS_ENABLED } from 'pages/my-services/utils/constants'

import { Text } from '@interco/inter-ui/components/Text'
import { TimelineType } from '@interco/inter-ui/components/Timeline'

import {
  ButtonContainer,
  SubTitleContainer,
  TrackingItem,
  TrackingItemTitle,
  PendingReasonContainer,
} from '../styles/ServiceDetails.styles'

type TTrackingItemViewProps = {
  title: string
  type: TimelineType
  content: { content: string; subContent?: string }
  hasVerticalBar?: boolean
  hasActionButton?: boolean
  buttonLabel?: string
  icon: string | undefined
  color: string
  children?: JSX.Element
  pendingReason?: string
  onClick?: () => void
}

export const TrackingItemView: FC<TTrackingItemViewProps> = ({
  title,
  type,
  content,
  pendingReason,
  hasVerticalBar = true,
  hasActionButton = false,
  buttonLabel = '',
  icon,
  color = 'var(--gray500)',
  children,
  onClick,
}) => (
  <TrackingItem
    title={title}
    type={type}
    hasVerticalBar={hasVerticalBar}
    icon={icon && <InterSvgIcon iconRef={icon} width={20} height={20} color={color} />}
  >
    <TrackingItemTitle variant="body-3" colorWeight={400}>
      {content.content}
    </TrackingItemTitle>

    {pendingReason && IS_SEND_DOCUMENTS_ENABLED && (
      <PendingReasonContainer>
        <Text variant="body-3" colorWeight={400}>
          {pendingReason}
        </Text>
      </PendingReasonContainer>
    )}

    {content.subContent && (
      <SubTitleContainer>
        <Text variant="body-3" colorWeight={500} bold>
          {content.subContent}
        </Text>
      </SubTitleContainer>
    )}

    {hasActionButton && (
      <ButtonContainer data-testid="tracking-item-send-documents">
        <Button onClick={onClick} data-testid="tracking-item-send-documents-button">
          {buttonLabel}
        </Button>
      </ButtonContainer>
    )}

    {children && children}
  </TrackingItem>
)
